import { hasComputedStyle } from "./has-computed-style.js";
/**
 * @public
 */
export function isImportant(device, property) {
    return hasComputedStyle(property, (_, source) => source.some((declaration) => declaration.important), device);
}
//# sourceMappingURL=is-important.js.map